export default __webpack_public_path__ + "static/media/Eina01-Bold.49585ad7.woff2";